import moment from 'moment';
import tenantPickerMixin from '../../../components/core/tenant/pickerMixin';
import ApiService from '../../../services/apiService';
import get from 'lodash/get';

import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';
import 'codemirror/theme/duotone-light.css';
import 'codemirror/mode/javascript/javascript.js';

export default {
  components: {
    codemirror,
  },
  mixins: [tenantPickerMixin],
  data() {
    return {
      transformers: [],
      filters: [],
      isLoading: false,

      formValid: false,
      formDialogOpen: false,
      cmLineNumbers: false,
    };
  },
  computed: {
    headerBG() {
      return './img/dtwin-factory1.png';
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    requiredRule() {
      return [(v) => !!v || this.$i18n_t('Common.fieldRequired')];
    },
    cmOptions() {
      return {
        tabSize: 4,
        mode: { name: 'javascript', json: true },
        firstLineNumber: 0,
        theme: this.$store.state.app.UiTheme ? 'base16-dark' : 'duotone-light',
        lineNumbers: this.cmLineNumbers,
        line: true,
        foldGutter: true,
        styleActiveLine: true,
        styleSelectedText: true,
        hintOptions: {
          completeSingle: false,
        },
        lineWrapping: false,
      };
    },
  },
  watch: {
    // preserve the selected tenant when switching between consumers, filters, and transformers
    selectedTenantId() {
      this.$store.state.app.consumers = {
        ...this.$store.state.app.consumers,
        tenantId: this.selectedTenantId,
      };
    },
  },
  mounted() {
    // TODO: disable root-account here? There can be valid bridges be configured, just no twins
    // this.loadTenants((t) => t.parentId);
    this.loadTenants(undefined, get(this.$store, 'state.app.consumers.tenantId'));
  },
  methods: {
    localizeDate(a) {
      if (a) {
        moment.locale(this.$store.state.app.language || window.navigator.userLanguage || window.navigator.language);
        return moment(a).format('L LTS');
      }
      return '-';
    },
    refreshForm() {
      setTimeout(() => {
        if (this.$refs.codemirror) {
          // required workaround to get the cursor appearing at the right spot
          // https://discuss.codemirror.net/t/codemirror-cursor-is-not-partially-visible/648/6
          this.$refs.codemirror.codemirror.refresh();
          this.$refs.codemirror.codemirror.focus();
        }
      }, 50);
    },
    onCmFocus() {
      this.refreshForm();
      this.cmLineNumbers = true;
    },
    closeDialog() {
      this.formDialogOpen = false;
    },

    fetchTransformers(selectedAccounts, options = { 'loading-flag': true }) {
      if (options['loading-flag']) {
        this.isLoading = true;
      }
      if (!selectedAccounts) {
        selectedAccounts = [];
      }
      const ids = selectedAccounts.map((acc) => acc.id);
      return ApiService.consumerTransformersFetch(ids)
        .then((data) => {
          this.transformers = data;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          if (options['loading-flag']) {
            this.isLoading = false;
          }
        });
    },
    fetchFilters(selectedAccounts, options = { 'loading-flag': true }) {
      if (options['loading-flag']) {
        this.isLoading = true;
      }
      if (!selectedAccounts) {
        selectedAccounts = [];
      }
      const ids = selectedAccounts.map((acc) => acc.id);
      return ApiService.consumerFiltersFetch(ids)
        .then((data) => {
          this.filters = data;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          if (options['loading-flag']) {
            this.isLoading = false;
          }
        });
    },
  },
};
